import { ReactElement } from 'react';

const VerticalMenuIcon = (props: TClassNameProps): ReactElement => (
	<svg width="6" height="26" viewBox="0 0 6 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<circle cx="3" cy="3" r="3" fill="currentColor" />
		<circle cx="3" cy="13" r="3" fill="currentColor" />
		<circle cx="3" cy="23" r="3" fill="currentColor" />
	</svg>
);

export default VerticalMenuIcon;
